<common-header [title]="this.title" [items]="items"></common-header>

<div class="content">
  <div class="container-fluid">
    <form role="form" [formGroup]="formSearch" (ngSubmit)="onSubmit()" #formObject="ngForm">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">
                Filtros de búsqueda
                <span *ngIf="dateRange != null"> - {{ dateRange }} </span>
              </h3>
              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div class="col-12 col-sm-3">
                  <app-common-daterangepicker
                    [controlFrom]="this.formSearch.get('from')"
                    [controlTo]="this.formSearch.get('to')"
                    [label]="'Rango Fecha de Evento'">
                  </app-common-daterangepicker>
                </div>
                <div class="col-12 col-sm-3">
                  <ticket-family-groups-combo [multiselect]="true" [control]="formSearch.get('ticketFamily')">
                  </ticket-family-groups-combo>
                </div>
                <div class="col-12 col-sm-3">
                  <common-input-select
                    class="form-control-sm"
                    [allowClear]="true"
                    [label]="'Tipo'"
                    [list]="this.ticketType"
                    formControlName="ticketType">
                  </common-input-select>
                </div>
                <div class="col-12 col-sm-3">
                  <common-input-select
                    [allowClear]="true"
                    class="form-control-sm"
                    [list]="this.issuedBy"
                    label="Originado por"
                    formControlName="issuedBy">
                  </common-input-select>
                </div>
                <div class="col-12 col-sm-3">
                  <common-input-select
                    class="form-control-sm"
                    [label]="'Estado Buscado'"
                    [list]="this.ticketState"
                    formControlName="ticketTrackerStatus"
                    (valueChanged)="updateFilters()">
                  </common-input-select>
                </div>
                <div class="col-12 col-sm-3">
                  <common-input-select
                    class="form-control-sm"
                    [label]="'Motivo de Anulación'"
                    [list]="this.cancellationReason"
                    formControlName="cancelReason">
                  </common-input-select>
                </div>
                <div class="col-12 col-sm-3">
                  <common-input-multiselect
                    class="form-control-sm"
                    [label]="'Motivo de Generación'"
                    [list]="this.generationReasonArray"
                    formControlName="generationReason">
                  </common-input-multiselect>
                </div>
                <div class="col-12 col-sm-3">
                  <common-input-select
                    class="form-control-sm"
                    [label]="'Estado Actual'"
                    [clearable]="true"
                    [list]="this.ticketState"
                    formControlName="ticketStatus"
                    (valueChanged)="updateFilters()">
                  </common-input-select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="d-flex justify-content-end">
                <button
                  (click)="formObject.submitted ? formObject.ngSubmit.emit() : onSubmit()"
                  data-card-widget="collapse"
                  class="btn btn-info">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <app-common-table
              [model]="data"
              [excel]="true"
              [title]="this.title"
              (onCustomButton)="onCustomButton($event)"></app-common-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
